export type Props = {
	title: string;
	value: string;
	onEdit: () => void;
};

export function WatchdogFilterBoxItem({ title, value, onEdit }: Props) {
	return (
		<div>
			<span class="text-dark-blue-50">{title}:</span> <span>{value}</span>
			{' - '}
			<button onClick={onEdit} className="link">
				změnit
			</button>
		</div>
	);
}
